/* eslint-disable max-len */
export const InfoIconDark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      aria-hidden
    >
      <g id="information">
        <path
          id="Vector"
          d="M12 2.67969C17.52 2.67969 22 7.15969 22 12.6797C22 18.1997 17.52 22.6797 12 22.6797C6.48 22.6797 2 18.1997 2 12.6797C2 7.15969 6.48 2.67969 12 2.67969Z"
          fill="#3B3B3B"
        />
        <g id="Vector_2">
          <path d="M13 9.67969H11V7.67969H13V9.67969Z" fill="white" />
          <path d="M13 17.6797H11V11.6797H13V17.6797Z" fill="white" />
        </g>
      </g>
    </svg>
  );
};
